// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"tabsContainer-9VdEN tabsContainer-1cvC0","tab":"tab-2JS8c tab-1ENf3","tabActive":"tabActive-3mX4W tabActive-2OFvo"};